module.exports = {"310151101":"城桥镇","310151102":"堡镇","310151103":"新河镇","310151104":"庙镇","310151105":"竖新镇","310151106":"向化镇","310151107":"三星镇","310151108":"港沿镇","310151109":"中兴镇","310151110":"陈家镇","310151111":"绿华镇","310151112":"港西镇","310151113":"建设镇","310151114":"新海镇","310151115":"东平镇","310151116":"长兴镇","310151201":"新村乡","310151202":"横沙乡","310151401":"前卫农场","310151402":"东平林场","310151501":"上实现代农业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310151.json
// module id = 825
// module chunks = 0